import React from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import SkillsTab from "./SkillsTab";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { useScrollPosition } from "../../hooks/useScrollPosition";

function Skills({ heading, hardSkills, softSkills, isDarkMode }) {
  const skillsTabRef = React.useRef();
  const [isScrolled, setIsScrolled] = React.useState(false);
  //const navbarDimensions = useResizeObserver(navbarMenuRef);

  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (!isScrolled && currPos.y - 400 < 0) setIsScrolled(true);
    },
    [],
    skillsTabRef
  );
  return (
    <Container
      ref={skillsTabRef}
      fluid
      className={`${isDarkMode ? "background-theme-darkest" : "bg-white"} m-0`}
      id="skills"
    >
      <Container className="p-5 ">
        <h2
          ref={skillsTabRef}
          className={`${
            isDarkMode ? "color-theme-light" : ""
          } display-4 pb-5 text-center`}
        >
          {heading}
        </h2>
        <Tabs
          className={`${isDarkMode ? "color-theme-light" : ""} skills-tabs`}
          defaultActiveKey="hard-skills"
          id="skills-tabs"
        >
          <Tab
            tabClassName={`${
              isDarkMode ? "color-theme-light background-theme-darkest" : ""
            } skills-tab lead`}
            eventKey="hard-skills"
            title="Technical Skills"
          >
            <Row
              className={`${isDarkMode ? "color-theme-light" : ""} pt-3 px-1`}
            >
              <SkillsTab
                skills={hardSkills}
                isDarkMode={isDarkMode}
                isScrolled={isScrolled}
              />
            </Row>
          </Tab>
          <Tab
            tabClassName={`${
              isDarkMode ? "color-theme-light background-theme-darkest" : ""
            } skills-tab lead`}
            eventKey="soft-skills"
            title="Soft Skills"
          >
            <Row
              className={`${isDarkMode ? "color-theme-light" : ""} pt-3 px-1`}
            >
              <SkillsTab
                skills={softSkills}
                isDarkMode={isDarkMode}
                isScrolled={isScrolled}
              />
            </Row>
          </Tab>
        </Tabs>
      </Container>
    </Container>
  );
}

export default Skills;
